import React, { useState } from "react";

function SellerLookup() {
  const [query, setQuery] = useState("");
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResult(null);
    setError(null);
    try {
        var url  = 'https://api.dtcargo.com.vn/api/orders/seller/'+encodeURIComponent(query);
      const res = await fetch(url);
      // (https://api.dtcargo.com.vn/api/orders/seller/${encodeURIComponent(query)}`);)
      if (!res.ok) {
        throw new Error(`Error: ${res.status}`);
      }
      const data = await res.text();
      setResult(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: "70vh",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center"
    }}>
      <h1>Seller Lookup</h1>
      <form
        onSubmit={handleSubmit}
        style={{
          display: "flex",
          gap: "12px",
          alignItems: "center",
          marginTop: "24px"
        }}
      >
        <input
          type="text"
          placeholder="Enter seller name or ID"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          style={{
            padding: "10px 16px",
            fontSize: "1rem",
            borderRadius: "6px",
            border: "1px solid #ccc",
            minWidth: "260px"
          }}
        />
        <button
          type="submit"
          style={{
            padding: "10px 24px",
            fontSize: "1rem",
            borderRadius: "6px",
            border: "none",
            background: "#bdbdbd",
            color: "#fff",
            cursor: "pointer"
          }}
          disabled={loading || !query}
        >
          {loading ? "Looking up..." : "Lookup"}
        </button>
      </form>
      {error && <div style={{ color: "red", marginTop: "16px" }}>{error}</div>}
      {result && (
        <pre style={{
          textAlign: "left",
          marginTop: "24px",
          background: "#f7f7f7",
          padding: "16px",
          borderRadius: "8px",
          maxWidth: "480px",
          overflowX: "auto"
        }}>
         <a href={'https://auctions.yahoo.co.jp/seller/' +result}>{result}</a>
        </pre>
      )}
    </div>
  );
}

export default SellerLookup;